var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"type":"chat"}},[(_vm.lastMessage && _vm.lastMessage.message)?_c('div',[(!_vm.lastMessage.seen)?_c('span'):_vm._e(),_c('Icon',{attrs:{"icon":"dashboard-chat-icon"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }